<template>
    <div>
        <AppHeader/>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">
                        <v-toolbar color="secondary" dark flat>
                            <v-toolbar-title class="font-weight-bold">Passwort festlegen</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <router-link to="/login">
                                <!-- <v-toolbar-title class="white--text text-decoration-none">Login</v-toolbar-title> -->
                            </router-link>
                        </v-toolbar>
                        <v-card-text>
                            <v-form ref="form" class="register" v-model="valid" lazy-validation>
                                <v-text-field
                                        prepend-icon="mdi-account"
                                        v-model="email"
                                        :rules="emailRules"
                                        label="E-mail"
                                        name="email"
                                        required
                                ></v-text-field>

                                <v-text-field
                                        v-model="password"
                                        :rules="passwordRules"
                                        label="Passwort"
                                        type="password"
                                        name="password"
                                        required
                                        prepend-icon="mdi-lock"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-alert v-if="errorBol" class="errorRegister" type="error">Bitte überprüfen Sie die angegebenen Daten.</v-alert>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <div>
                                Im Besitz eines Accounts? <br>
                                <router-link to="/login">
                                    <span class="blue--text">Stattdessen einloggen</span>
                                </router-link>
                            </div>
                            <v-btn
                                    :disabled="!valid"
                                    class="ml-5 white--text mb-2 mr-2"
                                    color="third"
                                    @click="validate"
                            >Register
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import firebase from "firebase";
    import AppHeader from "./AppHeader";

    export default {
        components: {
            AppHeader,
        },
        data: () => ({
            errorBol: false,
            valid: true,
            password: "",
            passwordRules: [
                (v) => !!v || "Ihr Passwort wird benötigt.",
                (v) => (v && v.length >= 8) || "Das Passwort muss mindestens 8 Zeichen lang sein.",
            ],
            email: "",
            emailRules: [
                (v) => !!v || "Ihre E-Mail wird benötigt.",
                (v) => /.+@.+\..+/.test(v) || "Bitte geben Sie eine gültige E-Mail ein.",
            ],
        }),
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    const registerForm = document.querySelector(".register");
                    const email = registerForm.email.value;
                    const password = registerForm.password.value;

                    firebase
                        .auth()
                        .createUserWithEmailAndPassword(email, password)
                        .then(() => {
                            this.$router.push("/").catch(() => {
                            });
                        })
                        .catch(() => {
                            this.errorBol = true;
                        });
                }
            },
        },
    };
</script>

<style scoped>
    .errorRegister {
        margin: auto;
        width: 90%;
    }
</style>